import { render, staticRenderFns } from "./forumHome.vue?vue&type=template&id=16437c56&scoped=true"
import script from "./forumHome.vue?vue&type=script&lang=js"
export * from "./forumHome.vue?vue&type=script&lang=js"
import style0 from "./forumHome.vue?vue&type=style&index=0&id=16437c56&prod&lang=scss&scoped=true"
import style1 from "./forumHome.vue?vue&type=style&index=1&id=16437c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16437c56",
  null
  
)

export default component.exports